import React from 'react'
import { FormattedMessage } from 'react-intl'

export default class IsInvalidRange {
  constructor({ value, allValues }) {
    this.allValues = allValues
    this.value = value
    this.errorMessage = <FormattedMessage id="invalid_confirm_password" />
  }

  validate() {
    const {
      allValues: { new_password },
      value,
    } = this

    if (value !== new_password) {
      return this.errorMessage
    }

    return null
  }
}
